export default __webpack_public_path__ + "static/media/ig-boost-campaign-img.ca30c462.png";